import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { differenceInCalendarDays } from 'date-fns';
import { NzNotificationService } from "ng-zorro-antd";
import { TITLE } from 'src/app/utils/enum';
import { FormFieldInfo } from '../../../../models/forms-response.models';

@Component({
    selector: 'app-component-datetime',
    templateUrl: './datetime.component.html',
    styleUrls: ['./datetime.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateTimeComponent implements OnInit, OnChanges, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Input() formGroup: FormGroup;
    @Input() formData: any;
    @Input() modalTitle:any;
    formFieldConfig: any;
    fieldConfig: any;
    isRequired: boolean;
    name: string;
    minDate: Date = null;
    maxDate: Date = null;
    hideTitle: boolean;
    value: string;
    fieldCode: string;
    tooltip: string;
    fieldDataInfo:any;
    taxCode="";
    formCode="";

    constructor(private nzModalNotification: NzNotificationService, private cdref: ChangeDetectorRef) {
    }

    ngOnChanges() {}

    ngOnInit(): void {
        try {
            this.formFieldConfig = this.formFieldInfo.formFieldConfig ? JSON.parse(this.formFieldInfo.formFieldConfig) : "";
            this.fieldConfig = this.formFieldInfo.fieldConfig ? JSON.parse(this.formFieldInfo.fieldConfig) : "";
            this.fieldCode = this.formFieldInfo.fieldCode;
            this.fieldDataInfo=this.formFieldInfo;
            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            this.name = (this.formFieldConfig && this.formFieldConfig.displayText) ? this.formFieldConfig.displayText : this.formFieldInfo.name;

            if (this.formFieldConfig) {
                this.minDate = this.formFieldConfig.minDate ? new Date(this.formFieldConfig.minDate) : null;
                this.maxDate = this.formFieldConfig.maxDate ? new Date(this.formFieldConfig.maxDate) : null;
            }

            if (this.fieldConfig) {
                this.minDate = this.fieldConfig.minDate ? new Date(this.fieldConfig.minDate) : null;
                this.maxDate = this.fieldConfig.maxDate ? new Date(this.fieldConfig.maxDate) : null;
            }
            this.formCode=localStorage.getItem('FORM_CODE');
            this.taxCode=localStorage.getItem('TAXCODE');
            this.tooltip = this.formFieldConfig && this.formFieldConfig.tooltip ? this.formFieldConfig.tooltip : "";
        } catch (error) {
            this.formFieldConfig = JSON.parse('{ "pattern": "" }');
            this.fieldConfig = JSON.parse('{ "keydownPattern": "" }');
        }
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    disabledDates = (current: Date) => {
        let dateDiffMin, dateDiffMax: number;
        if (this.minDate) 
            dateDiffMin = differenceInCalendarDays(current, this.minDate);
        if (this.maxDate) 
            dateDiffMax = differenceInCalendarDays(current, this.maxDate);
        return dateDiffMin < 0 || dateDiffMax > 0;
    }

    modelChange() {
        localStorage.setItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+this.fieldCode, this.value);
    }
    bindingData(){
        if (this.modalTitle == TITLE.ADD_DATA)//This case is: Click icon(+) to open popup
        {
            this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : '';
        }
        else if (this.modalTitle == TITLE.UPDATE_DATA) { //This case is: Click icon(edit) to open popup
            if (this.formData) {
                let objectData = this.formData;
                const keys = Object.keys(objectData);
                keys.forEach((key) => {
                    if (key == this.formFieldInfo.fieldCode) {
                        let value = objectData[key];
                        this.value = value;
                    }
                });
            }
        }
        else {
            let storageVal = localStorage.getItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode);
            if (storageVal) {
                this.value = storageVal;
            } else if (this.formData && this.formData[this.fieldCode]) {
                this.value = this.formData[this.fieldCode];
            } else {
                this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : '';
            }
        }
    }
}